import { NeqTreeNode } from './neq-tree-node.model';

/** Flat node with expandable and level information */
export class NeqTreeFlatNode {

  public identifier: string;
  constructor(
    public label: string,
    public type: string,
    public code: string,
    public level = 1,
    public expandable = false,
    public isLoading = false) {
    this.identifier = NeqTreeNode.getNodeIdentifier(this.type, this.code);
  }

}
